<template>
  <ChatPage
    v-if="viewer && uiControl"
    :viewer-id="viewer.id"
    :ui-control="uiControl"
    :has-line-activation-provider="viewer.hasLineActivationProvider"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ChatPage from './ChatPage.vue'
import { useFetchViewerOnChatPageQuery } from './ChatPageContainer.generated'

//
// ChatPageContainer は viewer の nullable を外すためだけのコンポーネント
//

const { result } = useFetchViewerOnChatPageQuery({
  fetchPolicy: 'cache-first', // だいたい他のどこかで viewer を取得しているので、キャッシュを優先する
})

const viewer = computed(() => result.value?.viewer)
const uiControl = computed(() => result.value?.uiControl)
</script>
